module.exports = __webpack_public_path__ + "static/media/google-play-button.17aa33c1.svg";